import { render } from "./RfidScanButton.vue?vue&type=template&id=2c9ee72d&scoped=true"
import script from "./RfidScanButton.vue?vue&type=script&lang=ts"
export * from "./RfidScanButton.vue?vue&type=script&lang=ts"

import "./RfidScanButton.vue?vue&type=style&index=0&id=2c9ee72d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c9ee72d"

export default script